








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class DescriptionBar extends Vue {
  @Prop()
  public value!: number;

  @Prop({ default: () => [] }) public descriptions!: string[];

  public defaultDescriptionList: string[] = [
    'totallyDisagree',
    'Disagree',
    'partiallyDisagree',
    'Neutral',
    'partiallyAgree',
    'Agree',
    'stronglyAgree',
  ];

  public getDescription(score: number): string | number {
    const descriptionList = this.defaultDescriptionList.map((item: string, index: number) =>
      !!this.descriptions[index] ? this.descriptions[index] : item,
    );
    const indexDescriptionList = score - 1 ?? 0;
    return this.$tc(descriptionList[indexDescriptionList]);
  }
}
